<template>
  <div class="people-screen">
    <div
      class="screen-title management-title"
      style="--management-title-bg: linear-gradient(135deg, #122a44, #0a1a2a); --management-title-border: none; --management-title-color: white;"
    >
      <div class="back-button">
        <el-button @click="navigateBack">
          返回主屏幕
        </el-button>
      </div>
      人员管理
    </div>
    
    <el-row
      :gutter="20"
      class="data-cards"
    >
      <el-col :span="6">
        <div
          ref="realPopulationCard"
          v-set-real-population-card-style
          class="data-card real-population-card custom-card"
          :style="realPopulationCardStyle"
          style="--real-population-bg: linear-gradient(135deg, #122a44, #0a1a2a); --real-population-border: none; --real-population-color: white;"
        >
          <h3 :style="realPopulationTitleStyle">
            实有人口
          </h3>
          <div
            class="big-number"
            :style="realPopulationNumberStyle"
          >
            875589
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div
          class="data-card male-ratio-card custom-card"
          style="--male-ratio-bg: linear-gradient(135deg, #122a44, #0a1a2a); --male-ratio-border: none; --male-ratio-color: white;"
        >
          <h3>男性比例</h3>
          <div class="big-number">
            52%
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div
          class="data-card female-ratio-card custom-card"
          style="--female-ratio-bg: linear-gradient(135deg, #122a44, #0a1a2a); --female-ratio-border: none; --female-ratio-color: white;"
        >
          <h3>女性比例</h3>
          <div class="big-number">
            48%
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div
          class="data-card elderly-card custom-card"
          style="--elderly-bg: linear-gradient(135deg, #122a44, #0a1a2a); --elderly-border: none; --elderly-color: white;"
        >
          <h3>60岁以上老人</h3>
          <div class="big-number">
            87558
          </div>
        </div>
      </el-col>
    </el-row>
    
    <el-row
      :gutter="20"
      class="charts-row"
      style="margin-top: -20px !important;"
    >
      <el-col :span="8">
        <el-card
          class="age-distribution-card"
          style="border: none !important; color: white !important; width: 100%; height: 380px;"
        >
          <h3 style="color: white !important; margin-top: -10px !important;">
            <span style="font-family: 'Source Han Serif CN', 'Noto Serif CJK SC', '思源宋体', serif; letter-spacing: 2px; font-size: 16px;">年龄分布</span><img
              src="@/assets/UI.png"
              alt="UI logo"
              style="height: 16px; margin-left: 8px; vertical-align: middle;"
            >
          </h3>
          <div class="chart-container">
            <div
              ref="ageDistributionChart"
              style="width: 100%; height: 300px;"
            />
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card
          class="gender-ratio-card"
          style="border: none !important; color: white !important; width: 100%; height: 380px;"
        >
          <h3 style="color: white !important; margin-top: -10px !important;">
            <span style="font-family: 'Source Han Serif CN', 'Noto Serif CJK SC', '思源宋体', serif; letter-spacing: 2px; font-size: 16px;">性别比例</span><img
              src="@/assets/UI.png"
              alt="UI logo"
              style="height: 16px; margin-left: 8px; vertical-align: middle;"
            >
          </h3>
          <div class="chart-container">
            <div
              ref="genderRatioChart"
              style="width: 100%; height: 300px;"
            />
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card
          class="search-card"
          style="border: none !important; color: white !important; width: 100%; height: 380px;"
        >
          <h3 style="color: white !important; margin-top: -10px !important;">
            <span style="font-family: 'Source Han Serif CN', 'Noto Serif CJK SC', '思源宋体', serif; letter-spacing: 2px; font-size: 16px;">人员搜索</span><img
              src="@/assets/UI.png"
              alt="UI logo"
              style="height: 16px; margin-left: 8px; vertical-align: middle;"
            >
          </h3>
          <div class="search-container">
            <el-input
              v-model="searchQuery"
              placeholder="请输入姓名或身份证号"
              class="search-input"
              style="margin-bottom: 15px;"
              @keyup.enter="searchPerson"
            >
              <template #prefix>
                <el-icon><Search /></el-icon>
              </template>
            </el-input>
            <el-button
              type="primary"
              class="search-button"
              style="width: 100%; margin-bottom: 15px;"
              @click="searchPerson"
            >
              搜索
            </el-button>
            
            <!-- 搜索结果显示区域 -->
            <div
              v-if="searchResult"
              class="search-result"
              style="background: rgba(255, 255, 255, 0.1); border-radius: 4px; padding: 10px; margin-top: 10px;"
            >
              <p style="margin: 5px 0; font-size: 14px;">
                <strong>姓名:</strong> {{ searchResult.name }}
              </p>
              <p style="margin: 5px 0; font-size: 14px;">
                <strong>性别:</strong> {{ searchResult.gender }}
              </p>
              <p
                v-if="searchResult.idCard"
                style="margin: 5px 0; font-size: 14px;"
              >
                <strong>身份证号:</strong> {{ searchResult.idCard }}
              </p>
              <p style="margin: 5px 0; font-size: 14px;">
                <strong>小区:</strong> {{ searchResult.community }}
              </p>
              <p style="margin: 5px 0; font-size: 14px;">
                <strong>楼牌号:</strong> {{ searchResult.building }}
              </p>
              <p style="margin: 5px 0; font-size: 14px;">
                <strong>单元:</strong> {{ searchResult.unit }}
              </p>
              <p style="margin: 5px 0; font-size: 14px;">
                <strong>室号:</strong> {{ searchResult.room }}
              </p>
            </div>
            <div
              v-else-if="searchError"
              class="search-error"
              style="color: #ff6b6b; margin-top: 10px; font-size: 14px;"
            >
              {{ searchError }}
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    
    <el-row
      :gutter="20"
      class="charts-row"
    >
      <el-col :span="12">
        <el-card
          class="population-trend-card"
          style="border: none !important; color: white !important; height: 260px;"
        >
          <h3 style="color: white !important; margin-top: -10px !important;">
            <span style="font-family: 'Source Han Serif CN', 'Noto Serif CJK SC', '思源宋体', serif; letter-spacing: 2px; font-size: 16px;">人口增长趋势</span><img
              src="@/assets/UI.png"
              alt="UI logo"
              style="height: 16px; margin-left: 8px; vertical-align: middle;"
            >
          </h3>
          <div class="chart-container">
            <div
              ref="populationTrendChart"
              style="width: 100%; height: 180px;"
            />
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card
          class="focus-people-card"
          style="border: none !important; color: white !important; margin-right: 50px !important; height: 260px;"
        >
          <h3 style="color: white !important; margin-top: -10px !important;">
            <span style="font-family: 'Source Han Serif CN', 'Noto Serif CJK SC', '思源宋体', serif; letter-spacing: 2px; font-size: 16px;">重点关注人员</span><img
              src="@/assets/UI.png"
              alt="UI logo"
              style="height: 16px; margin-left: 8px; vertical-align: middle;"
            >
          </h3>
          <div class="chart-container">
            <div
              ref="focusPeopleChart"
              style="width: 100%; height: 180px;"
            />
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

// ... existing code ...
<script>
import { ref, onMounted, nextTick, watch } from 'vue' // 导入 watch
import { useRouter } from 'vue-router'
import * as echarts from 'echarts'
import { Search } from '@element-plus/icons-vue'

// 创建自定义指令
const vSetRealPopulationCardStyle = {
  mounted(el) {
    el.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
    el.style.border = 'none'
    el.style.color = 'white'
    
    // 设置标题和数字的颜色
    const titleElement = el.querySelector('h3')
    if (titleElement) {
      titleElement.style.color = 'white'
    }
    
    const numberElement = el.querySelector('.big-number')
    if (numberElement) {
      numberElement.style.color = 'white'
    }
  },
  updated(el) {
    el.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
    el.style.border = 'none'
    el.style.color = 'white'
    
    // 设置标题和数字的颜色
    const titleElement = el.querySelector('h3')
    if (titleElement) {
      titleElement.style.color = 'white'
    }
    
    const numberElement = el.querySelector('.big-number')
    if (numberElement) {
      numberElement.style.color = 'white'
    }
  }
}

// 定义base component
const RealPopulationCardBase = {
  methods: {
    setRealPopulationCardStyle() {
      this.$nextTick(() => {
        const realPopulationCard = document.querySelector('.real-population-card')
        if (realPopulationCard) {
          realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
          realPopulationCard.style.border = 'none'
          realPopulationCard.style.color = 'white'
          
          // 设置标题和数字的颜色
          const titleElement = realPopulationCard.querySelector('h3')
          if (titleElement) {
            titleElement.style.color = 'white'
          }
          
          const numberElement = realPopulationCard.querySelector('.big-number')
          if (numberElement) {
            numberElement.style.color = 'white'
          }
        }
      })
    }
  },
  mounted() {
    this.setRealPopulationCardStyle()
  },
  updated() {
    this.setRealPopulationCardStyle()
  }
}

// 定义mixin
const realPopulationCardMixin = {
  methods: {
    setRealPopulationCardStyle() {
      this.$nextTick(() => {
        const realPopulationCard = document.querySelector('.real-population-card')
        if (realPopulationCard) {
          realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
          realPopulationCard.style.border = 'none'
          realPopulationCard.style.color = 'white'
          
          // 设置标题和数字的颜色
          const titleElement = realPopulationCard.querySelector('h3')
          if (titleElement) {
            titleElement.style.color = 'white'
          }
          
          const numberElement = realPopulationCard.querySelector('.big-number')
          if (numberElement) {
            numberElement.style.color = 'white'
          }
        }
      })
    }
  },
  mounted() {
    this.setRealPopulationCardStyle()
  },
  updated() {
    this.setRealPopulationCardStyle()
  }
}

export default {
    name: 'PeopleScreen',
    directives: {
      setRealPopulationCardStyle: vSetRealPopulationCardStyle
    },
    components: {
      Search
    },
    extends: RealPopulationCardBase,
    mixins: [realPopulationCardMixin],
  provide() {
    // 使用provide提供实有人口卡片的样式设置函数
    return {
      setRealPopulationCardStyle: () => {
        this.$nextTick(() => {
          const realPopulationCard = document.querySelector('.real-population-card')
          if (realPopulationCard) {
            realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
            realPopulationCard.style.border = 'none'
            realPopulationCard.style.color = 'white'
            
            // 设置标题和数字的颜色
            const titleElement = realPopulationCard.querySelector('h3')
            if (titleElement) {
              titleElement.style.color = 'white'
            }
            
            const numberElement = realPopulationCard.querySelector('.big-number')
            if (numberElement) {
              numberElement.style.color = 'white'
            }
          }
        })
      }
    }
  },
  inject: ['setRealPopulationCardStyle'],
  beforeRouteEnter(to, from, next) {
    // 在beforeRouteEnter钩子中再次尝试设置实有人口卡片的样式
    next(vm => {
      vm.$nextTick(() => {
        const realPopulationCard = document.querySelector('.real-population-card')
        if (realPopulationCard) {
          realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
          realPopulationCard.style.border = 'none'
          realPopulationCard.style.color = 'white'
          
          // 设置标题和数字的颜色
          const titleElement = realPopulationCard.querySelector('h3')
          if (titleElement) {
            titleElement.style.color = 'white'
          }
          
          const numberElement = realPopulationCard.querySelector('.big-number')
          if (numberElement) {
            numberElement.style.color = 'white'
          }
        }
      })
    })
  },
  beforeRouteUpdate(to, from, next) {
    // 在beforeRouteUpdate钩子中再次尝试设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
    })
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 在beforeRouteLeave钩子中再次尝试设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
    })
    next()
  },
  setup() {
    const router = useRouter()
    const ageDistributionChart = ref(null)
    const genderRatioChart = ref(null)
    const populationTrendChart = ref(null)
    const focusPeopleChart = ref(null)
    const realPopulationCard = ref(null)
    const searchQuery = ref('') // 添加搜索查询变量
    const searchResult = ref(null) // 搜索结果
    const searchError = ref('') // 搜索错误信息
    
    // 随机人员数据生成器
    const generateRandomPerson = (nameOrId) => {
      // 姓氏列表
      const surnames = ['张', '王', '李', '赵', '刘', '陈', '杨', '黄', '周', '吴', '徐', '孙', '胡', '朱', '高', '林', '何', '郭', '马', '罗']
      // 男性名字列表
      const maleNames = ['伟', '强', '磊', '军', '洋', '勇', '杰', '涛', '明', '超', '刚', '平', '辉', '鹏', '华', '波', '文', '亮', '建', '健']
      // 女性名字列表
      const femaleNames = ['芳', '娜', '敏', '静', '丽', '红', '燕', '艳', '玲', '娟', '琴', '兰', '萍', '颖', '洁', '琳', '晶', '倩', '蕾', '梅']
      // 小区列表
      const communities = ['阳光小区', '幸福家园', '和谐社区', '绿色家园', '美丽花园', '平安小区', '祥和社区', '锦绣家园', '明珠小区', '金色家园']
      // 楼号列表
      const buildings = ['1号楼', '2号楼', '3号楼', '4号楼', '5号楼', '6号楼', '7号楼', '8号楼', '9号楼', '10号楼']
      // 单元列表
      const units = ['1单元', '2单元', '3单元']
      // 室号列表
      const rooms = ['101室', '102室', '201室', '202室', '301室', '302室', '401室', '402室', '501室', '502室']
      
      // 判断输入的是姓名还是身份证号
      const isIdCard = /^\d{18}$/.test(nameOrId)
      let personName = ''
      let gender = ''
      
      if (isIdCard) {
        // 从身份证号中提取性别（第17位，奇数为男，偶数为女）
        const genderDigit = parseInt(nameOrId.charAt(16))
        gender = genderDigit % 2 === 1 ? '男' : '女'
        
        // 随机生成一个姓名，根据性别选择名字列表
        const surname = surnames[Math.floor(Math.random() * surnames.length)]
        const nameList = gender === '男' ? maleNames : femaleNames
        const givenName = nameList[Math.floor(Math.random() * nameList.length)]
        personName = surname + givenName
      } else {
        // 使用输入的姓名
        personName = nameOrId || ''
        
        // 如果没有提供姓名，则随机生成一个
        if (!personName) {
          const surname = surnames[Math.floor(Math.random() * surnames.length)]
          const isMale = Math.random() > 0.5
          gender = isMale ? '男' : '女'
          const nameList = isMale ? maleNames : femaleNames
          const givenName = nameList[Math.floor(Math.random() * nameList.length)]
          personName = surname + givenName
        } else {
          // 根据姓名随机分配性别
          gender = Math.random() > 0.5 ? '男' : '女'
        }
      }
      
      // 随机生成其他信息
      const community = communities[Math.floor(Math.random() * communities.length)]
      const building = buildings[Math.floor(Math.random() * buildings.length)]
      const unit = units[Math.floor(Math.random() * units.length)]
      const room = rooms[Math.floor(Math.random() * rooms.length)]
      
      return {
        name: personName,
        gender,
        community,
        building,
        unit,
        room,
        idCard: isIdCard ? nameOrId : '' // 如果是身份证号搜索，则显示身份证号
      }
    }
    
    // 搜索人员
    const searchPerson = () => {
      if (!searchQuery.value.trim()) {
        searchError.value = '请输入姓名或身份证号'
        searchResult.value = null
        return
      }
      
      const query = searchQuery.value.trim()
      
      // 检查是否为身份证号（纯数字）
      if (/^\d+$/.test(query)) {
        // 如果是纯数字，验证是否为18位身份证号
        if (query.length !== 18) {
          searchError.value = '身份证号必须为18位数字'
          searchResult.value = null
          return
        }
      }
      
      // 模拟搜索延迟
      setTimeout(() => {
        // 生成随机人员数据
        const randomPerson = generateRandomPerson(query)
        
        // 设置搜索结果
        searchResult.value = randomPerson
        searchError.value = ''
      }, 500)
    }
    
    // 计算属性：实有人口卡片样式
    const realPopulationCardStyle = {
      background: 'linear-gradient(135deg, #122a44, #0a1a2a)',
      border: 'none',
      color: 'white'
    }
    
    // 计算属性：实有人口卡片标题样式
    const realPopulationTitleStyle = {
      color: 'white'
    }
    
    // 计算属性：实有人口卡片数字样式
    const realPopulationNumberStyle = {
      color: 'white'
    }
    
    const navigateBack = () => {
      router.push({ name: 'MainDashboard' })
    }
    
    // 添加强制初始化图表函数
    const forceInitChart = (chartRef, option) => {
      if (!chartRef.value) {
        console.error('图表容器不存在')
        return null
      }
      
      // 检查容器尺寸
      const container = chartRef.value
      const rect = container.getBoundingClientRect()
      
      // 如果尺寸为0，尝试强制设置尺寸
      if (rect.width === 0 || rect.height === 0) {
        console.warn('图表容器尺寸为0，尝试强制设置尺寸')
        container.style.width = '100%'
        container.style.height = '300px'
        // 重新获取尺寸
        const newRect = container.getBoundingClientRect()
        if (newRect.width === 0 || newRect.height === 0) {
          console.error('强制设置尺寸后仍无效，创建临时div')
          // 创建临时div作为备选容器
          const tempDiv = document.createElement('div')
          tempDiv.style.width = '100%'
          tempDiv.style.height = '300px'
          document.body.appendChild(tempDiv)
          const chartInstance = echarts.init(tempDiv)
          chartInstance.setOption(option)
          // 延迟移除临时div
          setTimeout(() => {
            document.body.removeChild(tempDiv)
          }, 1000)
          return chartInstance
        }
      }
      
      // 正常初始化图表
      const chartInstance = echarts.init(container)
      chartInstance.setOption(option)
      
      // 添加窗口大小变化监听
      window.addEventListener('resize', () => {
        chartInstance.resize()
      })
      
      return chartInstance
    }
    
    onMounted(() => {
      // 使用 requestAnimationFrame 和 nextTick 确保DOM已准备好
      requestAnimationFrame(() => {
        nextTick(() => {
          // 直接操作实有人口卡片的DOM元素
          if (realPopulationCard.value) {
            realPopulationCard.value.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
            realPopulationCard.value.style.border = 'none'
            realPopulationCard.value.style.color = 'white'
            
            // 设置标题和数字的颜色
            const titleElement = realPopulationCard.value.querySelector('h3')
            if (titleElement) {
              titleElement.style.color = 'white'
            }
            
            const numberElement = realPopulationCard.value.querySelector('.big-number')
            if (numberElement) {
              numberElement.style.color = 'white'
            }
          }
          
          // 使用MutationObserver监听DOM变化
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' || mutation.type === 'childList') {
                const realPopulationCard = document.querySelector('.real-population-card')
                if (realPopulationCard) {
                  realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
                  realPopulationCard.style.border = 'none'
                  realPopulationCard.style.color = 'white'
                  
                  // 设置标题和数字的颜色
                  const titleElement = realPopulationCard.querySelector('h3')
                  if (titleElement) {
                    titleElement.style.color = 'white'
                  }
                  
                  const numberElement = realPopulationCard.querySelector('.big-number')
                  if (numberElement) {
                    numberElement.style.color = 'white'
                  }
                }
              }
            })
          })
          
          // 配置观察选项
          const config = { 
            attributes: true, 
            childList: true, 
            subtree: true,
            attributeOldValue: true,
            characterData: true
          }
          
          // 开始观察整个document
          observer.observe(document.body, config)
          
          // 保存observer引用，以便在组件卸载时断开观察
          window.realPopulationCardObserver = observer
          
          // 使用setInterval定期检查并应用样式
          const styleInterval = setInterval(() => {
            // 实有人口卡片样式
            const realPopulationCard = document.querySelector('.real-population-card')
            if (realPopulationCard) {
              realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
              realPopulationCard.style.border = 'none'
              realPopulationCard.style.color = 'white'
              
              // 设置标题和数字的颜色
              const titleElement = realPopulationCard.querySelector('h3')
              if (titleElement) {
                titleElement.style.color = 'white'
              }
              
              const numberElement = realPopulationCard.querySelector('.big-number')
              if (numberElement) {
                numberElement.style.color = 'white'
              }
            }
            
            // 男性比例卡片样式
            const maleRatioCard = document.querySelector('.male-ratio-card')
            if (maleRatioCard) {
              maleRatioCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
              maleRatioCard.style.border = 'none'
              maleRatioCard.style.color = 'white'
              
              // 设置标题和数字的颜色
              const maleTitleElement = maleRatioCard.querySelector('h3')
              if (maleTitleElement) {
                maleTitleElement.style.color = 'white'
              }
              
              const maleNumberElement = maleRatioCard.querySelector('.big-number')
              if (maleNumberElement) {
                maleNumberElement.style.color = 'white'
              }
            }
            
            // 女性比例卡片样式
            const femaleRatioCard = document.querySelector('.female-ratio-card')
            if (femaleRatioCard) {
              femaleRatioCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
              femaleRatioCard.style.border = 'none'
              femaleRatioCard.style.color = 'white'
              
              // 设置标题和数字的颜色
              const femaleTitleElement = femaleRatioCard.querySelector('h3')
              if (femaleTitleElement) {
                femaleTitleElement.style.color = 'white'
              }
              
              const femaleNumberElement = femaleRatioCard.querySelector('.big-number')
              if (femaleNumberElement) {
                femaleNumberElement.style.color = 'white'
              }
            }
            
            // 老人卡片样式
            const elderlyCard = document.querySelector('.elderly-card')
            if (elderlyCard) {
              elderlyCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
              elderlyCard.style.border = 'none'
              elderlyCard.style.color = 'white'
              
              // 设置标题和数字的颜色
              const elderlyTitleElement = elderlyCard.querySelector('h3')
              if (elderlyTitleElement) {
                elderlyTitleElement.style.color = 'white'
              }
              
              const elderlyNumberElement = elderlyCard.querySelector('.big-number')
              if (elderlyNumberElement) {
                elderlyNumberElement.style.color = 'white'
              }
            }
            
            // 人员管理标题样式
            const managementTitle = document.querySelector('.management-title')
            if (managementTitle) {
              managementTitle.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
              managementTitle.style.border = 'none'
              managementTitle.style.color = 'white'
              managementTitle.style.display = 'inline-block'
              managementTitle.style.padding = '10px 30px'
              managementTitle.style.borderRadius = '4px'
            }
          }, 100) // 每100毫秒检查一次
          
          // 保存interval引用，以便在组件卸载时清除
          window.realPopulationCardStyleInterval = styleInterval
          
          // 初始化年龄分布图表
          forceInitChart(ageDistributionChart, {
            tooltip: { trigger: 'axis' },
            grid: {
              left: '15%'  // 增加左边距，使柱形图向右移动
            },
            xAxis: { type: 'category', data: ['0-10', '11-20', '21-30', '31-40', '41-50', '51-60', '60+'] },
            yAxis: { type: 'value' },
            series: [{ data: [80000, 120000, 150000, 180000, 160000, 120000, 85589], type: 'bar', itemStyle: { color: '#66cbd4' } }]
          })
          
          // 初始化性别比例图表
          forceInitChart(genderRatioChart, {
            tooltip: { trigger: 'item' },
            color: ['#66cbd4', '#1c7f96'],
            series: [{
              name: '性别比例',
              type: 'pie',
              radius: ['40%', '70%'],
              data: [
                { value: 455306, name: '男性' },
                { value: 420283, name: '女性' }
              ]
            }]
          })
          
          // 初始化人口增长趋势图表
          forceInitChart(populationTrendChart, {
            tooltip: { trigger: 'axis' },
            xAxis: { type: 'category', data: ['2020', '2021', '2022', '2023', '2024', '2025'] },
            yAxis: { type: 'value' },
            series: [{ data: [750000, 780000, 800000, 820000, 850000, 875589], type: 'line', smooth: true }]
          })
          
          // 初始化重点关注人员图表
          forceInitChart(focusPeopleChart, {
            tooltip: { trigger: 'item' },
            color: ['#1E3A8A', '#2563EB', '#3B82F6', '#60A5FA'],
            series: [{
              name: '重点关注人员',
              type: 'pie',
              radius: ['40%', '70%'],
              data: [
                { value: 3000, name: '独居老人' },
                { value: 2500, name: '残障人士' },
                { value: 2000, name: '社区矫正人员' },
                { value: 3059, name: '其他' }
              ]
            }]
          })
        })
      })
    })
    
    // 监听实有人口卡片的变化
    watch(realPopulationCard, (newVal) => {
      if (newVal) {
        nextTick(() => {
          newVal.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
          newVal.style.border = 'none'
          newVal.style.color = 'white'
          
          // 设置标题和数字的颜色
          const titleElement = newVal.querySelector('h3')
          if (titleElement) {
            titleElement.style.color = 'white'
          }
          
          const numberElement = newVal.querySelector('.big-number')
          if (numberElement) {
            numberElement.style.color = 'white'
          }
        })
      }
    }, { immediate: true })
    
    return {
      ageDistributionChart,
      genderRatioChart,
      populationTrendChart,
      focusPeopleChart,
      realPopulationCard,
      searchQuery, // 添加搜索查询变量到返回对象
      searchResult, // 添加搜索结果到返回对象
      searchError, // 添加搜索错误信息到返回对象
      searchPerson, // 添加搜索方法到返回对象
      navigateBack,
      realPopulationCardStyle,
      realPopulationTitleStyle,
      realPopulationNumberStyle
    }
  },
  beforeCreate() {
    // 在beforeCreate钩子中设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
    })
  },
  created() {
    // 在created钩子中设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
    })
    
    // 调用inject的实有人口卡片的样式设置函数
    if (this.setRealPopulationCardStyle) {
      this.setRealPopulationCardStyle()
    }
  },
  beforeMount() {
    // 在beforeMount钩子中再次尝试设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
    })
  },
  mounted() {
    // 在mounted钩子中再次尝试设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
    })
  },
  updated() {
    // 在updated钩子中再次尝试设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
    })
  },
  beforeUpdate() {
    // 在beforeUpdate钩子中再次尝试设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
    })
  },
  beforeUnmount() {
    // 在beforeUnmount钩子中再次尝试设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
      
      // 断开MutationObserver的观察
      if (window.realPopulationCardObserver) {
        window.realPopulationCardObserver.disconnect()
        delete window.realPopulationCardObserver
      }
      
      // 清除setInterval
      if (window.realPopulationCardStyleInterval) {
        clearInterval(window.realPopulationCardStyleInterval)
        delete window.realPopulationCardStyleInterval
      }
      
      // 清除男性比例卡片interval
      if (window.maleRatioCardStyleInterval) {
        clearInterval(window.maleRatioCardStyleInterval)
        delete window.maleRatioCardStyleInterval
      }
      
      // 清除女性比例卡片interval
      if (window.femaleRatioCardStyleInterval) {
        clearInterval(window.femaleRatioCardStyleInterval)
        delete window.femaleRatioCardStyleInterval
      }
      
      // 清除老人卡片interval
      if (window.elderlyCardStyleInterval) {
        clearInterval(window.elderlyCardStyleInterval)
        delete window.elderlyCardStyleInterval
      }
      
      // 清除人员管理标题interval
      if (window.managementTitleStyleInterval) {
        clearInterval(window.managementTitleStyleInterval)
        delete window.managementTitleStyleInterval
      }
    })
  },
  errorCaptured() {
    // 在errorCaptured钩子中再次尝试设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
    })
  },
  renderTracked() {
    // 在renderTracked钩子中再次尝试设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
    })
  },
  renderTriggered() {
    // 在renderTriggered钩子中再次尝试设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
    })
  },
  activated() {
    // 在activated钩子中再次尝试设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
    })
  },
  deactivated() {
    // 在deactivated钩子中再次尝试设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
    })
  },
  serverPrefetch() {
    // 在serverPrefetch钩子中再次尝试设置实有人口卡片的样式
    this.$nextTick(() => {
      const realPopulationCard = document.querySelector('.real-population-card')
      if (realPopulationCard) {
        realPopulationCard.style.background = 'linear-gradient(135deg, #122a44, #0a1a2a)'
        realPopulationCard.style.border = 'none'
        realPopulationCard.style.color = 'white'
        
        // 设置标题和数字的颜色
        const titleElement = realPopulationCard.querySelector('h3')
        if (titleElement) {
          titleElement.style.color = 'white'
        }
        
        const numberElement = realPopulationCard.querySelector('.big-number')
        if (numberElement) {
          numberElement.style.color = 'white'
        }
      }
    })
  }
}
</script>
// ... existing code ...

<style scoped>
.people-screen {
  background-color: #000000;
  color: white;
  padding: 20px;
  min-height: 100vh; /* 确保容器有足够高度 */
}

.screen-title {
  font-size: 32px;
  font-weight: bold;
  color: white;
  letter-spacing: 2px;
  text-align: center;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-button .el-button {
  background: linear-gradient(135deg, #122a44, #0a1a2a);
  border: none;
  color: white;
}

.data-cards {
  margin-bottom: 20px;
  margin-top: -20px;
  margin-left: -10px !important;
  margin-right: -10px !important;
  display: grid !important;
  grid-template-columns: repeat(4, 1fr) !important;
  justify-items: start !important;
  gap: 20px !important;
}

.data-card {
  border: none !important;
  border-radius: 4px !important;
  background: linear-gradient(135deg, #122a44, #0a1a2a) !important;
  background-image: 
    radial-gradient(circle at 30% 30%, rgba(24, 144, 255, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 70% 70%, rgba(24, 144, 255, 0.1) 0%, transparent 40%) !important;
  color: white !important;
  text-align: center !important;
  padding: 0px !important;
  box-sizing: border-box !important;
}

/* 覆盖Element UI卡片样式 */
:deep(.data-card .el-card__body) {
  background: linear-gradient(135deg, #122a44, #0a1a2a) !important;
  background-image: 
    radial-gradient(circle at 30% 30%, rgba(24, 144, 255, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 70% 70%, rgba(24, 144, 255, 0.1) 0%, transparent 40%) !important;
  border: none !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 15px !important;
  box-sizing: border-box !important;
}

/* 自定义卡片样式 */
.custom-card {
  padding: 0px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

/* 实有人口卡片特定样式 */
.real-population-card {
  background: var(--real-population-bg, linear-gradient(135deg, #122a44, #0a1a2a)) !important;
  border: var(--real-population-border, none) !important;
  color: var(--real-population-color, white) !important;
  animation: forceRealPopulationCardStyle 1s infinite;
  margin-left: -10px !important;
  width: calc(100% + 250px) !important;
}

/* 男性比例卡片特定样式 */
.male-ratio-card {
  background: var(--male-ratio-bg, linear-gradient(135deg, #122a44, #0a1a2a)) !important;
  border: var(--male-ratio-border, none) !important;
  color: var(--male-ratio-color, white) !important;
  animation: forceMaleRatioCardStyle 1s infinite;
  margin-left: 10px !important;
  width: calc(100% + 250px) !important;
}

/* 女性比例卡片特定样式 */
.female-ratio-card {
  background: var(--female-ratio-bg, linear-gradient(135deg, #122a44, #0a1a2a)) !important;
  border: var(--female-ratio-border, none) !important;
  color: var(--female-ratio-color, white) !important;
  animation: forceFemaleRatioCardStyle 1s infinite;
  margin-left: 20px !important;
  width: calc(100% + 250px) !important;
}

/* 老人卡片特定样式 */
.elderly-card {
  background: var(--elderly-bg, linear-gradient(135deg, #122a44, #0a1a2a)) !important;
  border: var(--elderly-border, none) !important;
  color: var(--elderly-color, white) !important;
  animation: forceElderlyCardStyle 1s infinite;
  margin-left: 30px !important;
  width: calc(100% + 250px) !important;
}

/* 人员管理标题特定样式 */
.management-title {
  background: var(--management-title-bg, linear-gradient(135deg, #122a44, #0a1a2a)) !important;
  border: var(--management-title-border, none) !important;
  color: var(--management-title-color, white) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 10px 120px !important;
  border-radius: 4px;
  white-space: nowrap;
  text-align: center;
  width: auto;
  position: relative;
  margin-top: -20px !important;
  margin-left: -10px !important;
  margin-right: -10px !important;
  min-width: 300px !important;
}

.back-button {
  margin-bottom: 0;
  text-align: left;
  margin-right: 20px;
  position: absolute;
  left: 20px;
}

@keyframes forceRealPopulationCardStyle {
  0% {
    background: var(--real-population-bg, linear-gradient(135deg, #122a44, #0a1a2a)) !important;
    border: var(--real-population-border, none) !important;
    color: var(--real-population-color, white) !important;
  }
  100% {
    background: var(--real-population-bg, linear-gradient(135deg, #122a44, #0a1a2a)) !important;
    border: var(--real-population-border, none) !important;
    color: var(--real-population-color, white) !important;
  }
}

@keyframes forceMaleRatioCardStyle {
  0% {
    background: var(--male-ratio-bg, linear-gradient(135deg, #122a44, #0a1a2a)) !important;
    border: var(--male-ratio-border, none) !important;
    color: var(--male-ratio-color, white) !important;
  }
  100% {
    background: var(--male-ratio-bg, linear-gradient(135deg, #122a44, #0a1a2a)) !important;
    border: var(--male-ratio-border, none) !important;
    color: var(--male-ratio-color, white) !important;
  }
}

@keyframes forceFemaleRatioCardStyle {
  0% {
    background: var(--female-ratio-bg, linear-gradient(135deg, #122a44, #0a1a2a)) !important;
    border: var(--female-ratio-border, none) !important;
    color: var(--female-ratio-color, white) !important;
  }
  100% {
    background: var(--female-ratio-bg, linear-gradient(135deg, #122a44, #0a1a2a)) !important;
    border: var(--female-ratio-border, none) !important;
    color: var(--female-ratio-color, white) !important;
  }
}

@keyframes forceElderlyCardStyle {
  0% {
    background: var(--elderly-bg, linear-gradient(135deg, #122a44, #0a1a2a)) !important;
    border: var(--elderly-border, none) !important;
    color: var(--elderly-color, white) !important;
  }
  100% {
    background: var(--elderly-bg, linear-gradient(135deg, #122a44, #0a1a2a)) !important;
    border: var(--elderly-border, none) !important;
    color: var(--elderly-color, white) !important;
  }
}

@keyframes forceAgeDistributionCardStyle {
  0% {
    background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
    border: none !important;
    color: white !important;
  }
  100% {
    background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
    border: none !important;
    color: white !important;
  }
}

@keyframes forcePopulationTrendCardStyle {
  0% {
    background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
    border: none !important;
    color: white !important;
  }
  100% {
    background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
    border: none !important;
    color: white !important;
  }
}

@keyframes forceFocusPeopleCardStyle {
  0% {
    background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
    border: none !important;
    color: white !important;
  }
  100% {
    background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
    border: none !important;
    color: white !important;
  }
}

@keyframes forceGenderRatioCardStyle {
  0% {
    background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
    border: none !important;
    color: white !important;
  }
  100% {
    background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
    border: none !important;
    color: white !important;
  }
}

.real-population-card h3 {
  color: var(--real-population-color, white) !important;
  animation: forceRealPopulationTitleStyle 1s infinite;
  margin-bottom: 10px !important;
  margin-top: 5px !important;
}

.male-ratio-card h3 {
  color: var(--male-ratio-color, white) !important;
  animation: forceMaleRatioTitleStyle 1s infinite;
  margin-bottom: 10px !important;
  margin-top: 5px !important;
}

.female-ratio-card h3 {
  color: var(--female-ratio-color, white) !important;
  animation: forceFemaleRatioTitleStyle 1s infinite;
  margin-bottom: 10px !important;
  margin-top: 5px !important;
}

.elderly-card h3 {
  color: var(--elderly-color, white) !important;
  animation: forceElderlyTitleStyle 1s infinite;
  margin-bottom: 10px !important;
  margin-top: 5px !important;
}

@keyframes forceRealPopulationTitleStyle {
  0% {
    color: var(--real-population-color, white) !important;
  }
  100% {
    color: var(--real-population-color, white) !important;
  }
}

@keyframes forceMaleRatioTitleStyle {
  0% {
    color: var(--male-ratio-color, white) !important;
  }
  100% {
    color: var(--male-ratio-color, white) !important;
  }
}

@keyframes forceFemaleRatioTitleStyle {
  0% {
    color: var(--female-ratio-color, white) !important;
  }
  100% {
    color: var(--female-ratio-color, white) !important;
  }
}

@keyframes forceElderlyTitleStyle {
  0% {
    color: var(--elderly-color, white) !important;
  }
  100% {
    color: var(--elderly-color, white) !important;
  }
}

.real-population-card .big-number {
  color: var(--real-population-color, white) !important;
  animation: forceRealPopulationNumberStyle 1s infinite;
  margin-top: -5px !important;
}

.male-ratio-card .big-number {
  color: var(--male-ratio-color, white) !important;
  animation: forceMaleRatioNumberStyle 1s infinite;
  margin-top: -5px !important;
}

.female-ratio-card .big-number {
  color: var(--female-ratio-color, white) !important;
  animation: forceFemaleRatioNumberStyle 1s infinite;
  margin-top: -5px !important;
}

.elderly-card .big-number {
  color: var(--elderly-color, white) !important;
  animation: forceElderlyNumberStyle 1s infinite;
  margin-top: -5px !important;
}

@keyframes forceRealPopulationNumberStyle {
  0% {
    color: var(--real-population-color, white) !important;
  }
  100% {
    color: var(--real-population-color, white) !important;
  }
}

@keyframes forceMaleRatioNumberStyle {
  0% {
    color: var(--male-ratio-color, white) !important;
  }
  100% {
    color: var(--male-ratio-color, white) !important;
  }
}

@keyframes forceFemaleRatioNumberStyle {
  0% {
    color: var(--female-ratio-color, white) !important;
  }
  100% {
    color: var(--female-ratio-color, white) !important;
  }
}

@keyframes forceElderlyNumberStyle {
  0% {
    color: var(--elderly-color, white) !important;
  }
  100% {
    color: var(--elderly-color, white) !important;
  }
}

.big-number {
  font-size: 16px;
  font-weight: bold;
  margin: 2px 0;
}

.charts-row {
  margin-bottom: 20px;
}

/* 将年龄分布、性别比例和人员搜索容器向上移动 */
.age-distribution-card,
.gender-ratio-card,
.search-card {
  margin-top: -15px !important;
}

/* 将人口增长趋势和重点关注人员容器向上移动 */
.population-trend-card,
.focus-people-card {
  margin-top: -15px !important;
}

/* 使容器向两端延伸 - 单独设置每个容器 */

.focus-people-card {
  width: 105% !important;
  margin-left: 72px !important;
}

.chart-card {
  border: none;
  border-radius: 4px;
  background: linear-gradient(135deg, #122a44, #0a1a2a) !important;
  background-image: 
    radial-gradient(circle at 30% 30%, rgba(24, 144, 255, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 70% 70%, rgba(24, 144, 255, 0.1) 0%, transparent 40%) !important;
  color: white;
  padding: 15px;
  box-sizing: border-box;
}

.chart-container {
  width: 100%;
  height: 300px !important; /* 添加 !important 确保优先级 */
  min-height: 300px; /* 设置最小高度 */
  box-sizing: border-box; /* 确保 padding 和 border 不影响尺寸 */
}

/* 添加额外的样式覆盖，确保 Element UI 卡片不影响图表容器 */
:deep(.chart-card .el-card__body) {
  height: 100%;
  padding: 15px !important;
  box-sizing: border-box;
  background: linear-gradient(135deg, #122a44, #0a1a2a) !important;
  background-image: 
    radial-gradient(circle at 30% 30%, rgba(24, 144, 255, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 70% 70%, rgba(24, 144, 255, 0.1) 0%, transparent 40%) !important;
}

.age-distribution-card {
  border: none;
  border-radius: 4px;
  background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
  color: white;
  padding: 15px;
  box-sizing: border-box;
  box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.7), 0 0 15px rgba(25, 118, 210, 0.2);
  position: relative;
  overflow: hidden;
  animation: forceAgeDistributionCardStyle 1s infinite;
  width: calc(100% - 0px) !important;
  margin-left: -10px !important;
  margin-right: -10px !important;
}

.age-distribution-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(25, 118, 210, 0.1) 0%, rgba(25, 118, 210, 0) 70%);
  pointer-events: none;
}

.age-distribution-card .el-card__body {
  background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
  animation: forceAgeDistributionCardStyle 1s infinite;
}

.gender-ratio-card {
  border: none;
  border-radius: 4px;
  background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
  color: white;
  padding: 15px;
  box-sizing: border-box;
  box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.7), 0 0 15px rgba(25, 118, 210, 0.2);
  position: relative;
  overflow: hidden;
  animation: forceGenderRatioCardStyle 1s infinite;
  width: calc(100% - 0px) !important;
  margin-left: -10px !important;
  margin-right: -0px !important;
  transform: translateX(12px) !important;
}

.gender-ratio-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(25, 118, 210, 0.1) 0%, rgba(25, 118, 210, 0) 70%);
  pointer-events: none;
}

.gender-ratio-card .el-card__body {
  background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
  animation: forceGenderRatioCardStyle 1s infinite;
}

.population-trend-card {
  border: none;
  border-radius: 4px;
  background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
  color: white;
  padding: 15px;
  box-sizing: border-box;
  box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.7), 0 0 15px rgba(25, 118, 210, 0.2);
  position: relative;
  overflow: hidden;
  animation: forcePopulationTrendCardStyle 1s infinite;
  margin-left: -9px !important;
}

.population-trend-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(25, 118, 210, 0.1) 0%, rgba(25, 118, 210, 0) 70%);
  pointer-events: none;
}

.population-trend-card .el-card__body {
  background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
  animation: forcePopulationTrendCardStyle 1s infinite;
}

/* 使用更具体的选择器和更强的样式规则 */
.people-screen .el-row:last-child .el-col:last-child .focus-people-card {
  border: none;
  border-radius: 4px;
  background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
  color: white;
  padding: 15px;
  box-sizing: border-box;
  box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.7), 0 0 15px rgba(25, 118, 210, 0.2);
  position: relative;
  overflow: hidden;
  animation: forceFocusPeopleCardStyle 1s infinite;
  width: calc(100% - 60px) !important;
  margin-right: 60px !important;
}

.focus-people-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(25, 118, 210, 0.1) 0%, rgba(25, 118, 210, 0) 70%);
  pointer-events: none;
}

.focus-people-card .el-card__body {
  background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
  animation: forceFocusPeopleCardStyle 1s infinite;
}

.search-card {
  border: none;
  border-radius: 4px;
  background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
  color: white;
  padding: 15px;
  box-sizing: border-box;
  box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.7), 0 0 15px rgba(25, 118, 210, 0.2);
  position: relative;
  overflow: hidden;
  width: calc(100% - 0px) !important;
  margin-left: 10px;
  margin-right: 0 !important;
  transform: translateX(2px) !important;
}

.search-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(25, 118, 210, 0.1) 0%, rgba(25, 118, 210, 0) 70%);
  pointer-events: none;
}

.search-card .el-card__body {
  background: linear-gradient(135deg, #041e33 0%, #0a2847 40%, #122a44 60%, #1a3a5c 100%) !important;
}
</style>